import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditArticleModal from 'appSrc/AdminPanel/pages/Modals/Article/EditArticleModal';
import EditArticleTextModal from 'appSrc/AdminPanel/pages/Modals/Article/EditArticleTextModal';
import ProductSearchModal from 'appSrc/AdminPanel/pages/Modals/ProductSearch';
import { ExternalLink, InternalLink, PrimaryButton, DLRichTextOutput } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import { VideoPlayer } from 'appSrc/components/Shards';
import SortableProductsTable from './ProductsTable';
import TagDisplay from 'appSrc/components/Tag/Display';
import AssociatedContentTab from './AssociatedContentTab';
import { parseYouTubeUrl } from 'appSrc/utils';
import { encodeForURI } from 'appSrc/utils';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';

class IndividualArticlePage extends Component {
    state = {
        fetching: true,
        article: {},
        products: [],
        tab: 'text',
        editing: false,
        editingText: false,
        addingProduct: false,
        fetchingAssociated: true,
        associatedContent: [],
    }
    componentDidMount() {
        this.loadArticle( this.props.match.params.aid );
    }
    componentDidUpdate( prevProps ) {
        if( this.props.match.params.aid !== prevProps.match.params.aid ) {
            this.setState( { fetching: true } );
            this.loadArticle( this.props.match.params.aid );
        }
    }
    loadArticle = ( id ) => {
        this.props.getArticle( id )
        .then( ( article ) => {
            this.setState( {
                fetching: false,
                article: article,
            } );
        } )
        .catch( () => {
            this.props.redirect( '/admin/content/' );
        } );

        this.props.getArticleProducts( id )
        .then( ( products ) => {
            this.setState( { products } );
        } )
        .catch( () => {} );

        this.loadAssociatedContent();
    }
    loadAssociatedContent = () => {
        let id = this.props.match.params.aid;

        this.props.getAssociatedContent( id )
        .then( ( ac ) => {
            this.setState( {
                fetchingAssociated: false,
                associatedContent: ac,
            } );
        } )
        .catch( () => {
            alert( 'Couldn\'t retrieve associated content' );

            this.setState( {
                fetchingAssociated: false,
                associatedContent: [],
            } );
        } );
    }
    openEditModal = () => {
        this.setState( { editing: true } );
    }
    onEditSubmit = ( article ) => {
        if( article == null ) {
            this.props.redirect( '/admin/content/' );
        } else {
            this.setState( { article: { ...article }, editing: false } );
        }
    }
    onEditClose = () => {
        this.setState( { editing: false } );
    }

    openTextModal = () => {
        this.setState( { editingText: true } );
    }
    onTextSubmit = ( article ) => {
        if( article == null ) {
            this.props.redirect( '/admin/content/' );
        } else {
            this.setState( { article: article, editingText: false } );
        }
    }
    onTextClose = () => {
        this.setState( { editingText: false } );
    }

    openProductModal = () => {
        this.setState( { addingProduct: true } );
    }
    closeProductModal = () => {
        this.setState( { addingProduct: false } );
    }
    addProduct = ( product ) => {
        var desireIds = this.state.products.map( product => product.desireid );
        desireIds.push( product.desireid );
        this.props.updateArticle( this.state.article.id, { desireIds } )
        .then( () => {
            this.setState( ( altState ) => {
                altState.article.desires.push( product );
                altState.products = altState.products.concat( [ product ] );
                return altState;
            } );
        } );
    }
    removeProduct = ( index ) => {
        var desireIds = this.state.products.map( product => product.desireid );
        desireIds.splice( index, 1 );
        this.props.updateArticle( this.state.article.id, { desireIds } )
        .then( () => {
            this.setState( ( altState ) => {
                altState.products.splice( index, 1 );
                altState.products = altState.products.slice( 0 );
                return altState;
            } );
        } );
    }

    onManualProductSort = ( o, s, data ) => {
        this.setState( ( prevState ) => {
            var movedProduct = prevState.products.splice( data.oldIndex, 1 )[ 0 ];
            prevState.products.splice( data.newIndex, 0, movedProduct );
            prevState.products = prevState.products.slice( 0 );
            var orderedProductIds = prevState.products.map( product => product.desireid );
            this.props.updateArticle( prevState.article.id, { desireIds: orderedProductIds } );
            return prevState;
        } );
    }


    render() {
        const { fetching, article, products, associatedContent } = this.state;

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }
        const author = article.author || {};

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit Article Data' onClick={ this.openEditModal } style={ { marginRight: '15px' } } />
                            <PrimaryButton label='Edit Article Text' onClick={ this.openTextModal } style={ { marginRight: '15px' } } />
                            <PrimaryButton label='Add Product' onClick={ this.openProductModal } style={ { marginRight: '15px' } } />
                            <ExternalLink target='_blank' to={ `${ tdcDomainMatch() }/articles/${ article.id }/${ encodeForURI(article.title) }` }>
                                <PrimaryButton reverse label='Public View' />
                            </ExternalLink>
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div>
                            { article.video_url ?
                                <VideoPlayer videoId={ parseYouTubeUrl( article.video_url ) } coverImage={ article.cover_image } />
                                :
                                <ListCoverImage coverImage={ article.cover_image } />
                            }
                        </div>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ article.title }</h2>
                            </div>
                            <div className={ style.author }>
                                <p>Created by: <InternalLink to={ `/admin/users/${ author.userid }` }>{ author.displayName }</InternalLink></p>
                            </div>
                            <div className={ style.contentType }>
                                <p>Content Type: { ( article.content_type || {} ).name }</p>
                            </div>
                            <div className={ style.contentType }>
                                <p>Hosted File: { ( article.contentS3File || {} ).key }</p>
                            </div>
                            <div className={ style.categories }>
                                <p>{ article.categories.map( category => category.name ).join( ', ' ) }</p>
                            </div>
                            <div className={ style.tags }>
                                <TagDisplay tags={ article.tags } multiLine linked={ false } />
                            </div>
                            
                        </div>
                    </div>
                    <div className={ style.tabs }>
                        <div className={ style.tabOption }
                        onClick={ () => { this.setState( { tab: 'text' } ); } }
                        data-active={ this.state.tab == 'text' }>
                            Text
                        </div>
                        <div className={ style.tabOption }
                        onClick={ () => { this.setState( { tab: 'products' } ); } }
                        data-active={ this.state.tab == 'products' }>
                            Products ({ products.length })
                        </div>
                        <div className={ style.tabOption }
                        onClick={ () => { this.setState( { tab: 'associated' } ); } }
                        data-active={ this.state.tab == 'associated' }>
                            Associated Content ({ associatedContent.length })
                        </div>
                    </div>
                </div>
                <div className={ style.body }>
                    { this.state.tab == 'text' &&
                        <div className={ style.articleDescription }>
                            <DLRichTextOutput content={ article.primary_text } products={ products } />
                        </div>
                    }
                    { this.state.tab === 'products' &&
                        <SortableProductsTable products={ products }
                        removeProduct={ this.removeProduct }
                        onSort={ this.onManualProductSort } />
                    }
                    { this.state.tab === 'associated' &&
                        <AssociatedContentTab id={ article.id } content={ associatedContent }
                        onUpdate={ this.loadAssociatedContent }
                        fetching={ this.state.fetchingAssociated } />
                    }
                </div>
                { this.state.editing &&
                    <EditArticleModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    article={ article } />
                }
                { !fetching && this.state.editingText &&
                    <EditArticleTextModal closeModal={ this.onTextClose }
                    onSubmit={ this.onTextSubmit }
                    article={ article } />
                }
                { this.state.addingProduct &&
                    <ProductSearchModal closeModal={ this.closeProductModal }
                    onSubmit={ this.addProduct } markedProducts={ products } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        getArticle: ( id ) => {
            return dAPI.get( `/admin/content/${ id }` );
        },
        updateArticle: ( id, data ) => {
            return dAPI.patch( `/admin/content/${ id }`, dAPI.clean.admin.article( data ) );
        },
        reorderArticle: ( id, orderedDesireIds ) => {
            return dAPI.patch( `/desires/orderByArticle/${ id }`, { orderedDesireIds } );
        },
        getArticleProducts: ( id ) => {
            return dAPI.get( `/admin/curated-articles/${ id }/desires` );
        },
        getAssociatedContent: ( id ) => {
            return dAPI.get( `/admin/content/${ id }/associated` );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualArticlePage );
